import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface MenuPlanParamsState {
  params: any; // Define a more specific type if possible
}

const initialState: MenuPlanParamsState = {
  params: null,
};

const menuProjecionSelectionParams = createSlice({
  name: 'ProjecionSelectionParams',
  initialState,
  reducers: {
    setMenuProjectionSelectionParams(state, action: PayloadAction<any>) {
      state.params = action.payload;
    },
  },
});

export const { setMenuProjectionSelectionParams } = menuProjecionSelectionParams.actions;

export default menuProjecionSelectionParams.reducer;
